import { VerificationSource } from '../types/event'

/**
 * 현재 경로에 따라 본인인증 소스를 반환
 * @param pathname - 현재 경로 (ex: /events/123, /hospitals/456, /doctors/789)
 * @returns 본인인증 소스
 */
export const getSourceFromPath = (pathname: string): VerificationSource => {
  if (pathname.includes('/events/')) return 'event_detail'
  if (pathname.includes('/hospitals/')) return 'hospital_detail'
  if (pathname.includes('/doctors/')) return 'doctor_detail'
  return 'event_detail'
}
